import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import * as types from 'constants/actionTypes';
import { PlatformType } from 'constants/platformType';
import { getPlatform } from 'util/platform';
import { LOGIN_POPUP } from "constants/loginTypes";

export const usePaiQuizCommand = () => {
    const [, globalDispatch] = useStore(StoreTypes.global);
    const [, readerDispatch] = useStore(StoreTypes.reader);
    const [, loginDispatch] = useStore(StoreTypes.login);
    const [{token}] = useStore(StoreTypes.user);

    const execute = useCallback(async ({ json: { src }, pageIndex }) => {
        if(!token){
            loginDispatch({ type: LOGIN_POPUP, popupState: true });
            return;
        }
        try {
            globalDispatch({ type: types.OPEN_PAIQUIZ_MODAL })
            let paiquizSrc = src;
            if (window.electron && !token) paiquizSrc = 'unLogin';
            readerDispatch({type: types.SET_PAIQUIZ_SRC, paiquizSrc})
            readerDispatch({type: types.SET_PAIQUIZ_PAGEINDEX, paiquizPageIndex: pageIndex})
            // console.log("PaiQuiz", src)
        } catch (e) {
            console.error('PaiQuizCommand execute error', e);
        }
    }, [globalDispatch, readerDispatch, token]);

    return { execute };
};
